import { Box, Flex, Skeleton } from '@ergolabs/ui-kit';
import React, { FC } from 'react';
import styled from 'styled-components';

const StyledSkeletonBlock = styled(Skeleton.Block)`
  border-radius: var(--spectrum-border-radius-l) !important;
`;

export const LoadingView: FC = () => (
  <Box borderRadius="l" padding={4}>
    <Flex col>
      <Flex.Item width="50%" marginBottom={6}>
        <StyledSkeletonBlock active size="small" />
      </Flex.Item>
      <Flex.Item width="100%" marginBottom={6}>
        <StyledSkeletonBlock active size="large" />
      </Flex.Item>
      <Flex.Item width="100%">
        <StyledSkeletonBlock active size="large" />
      </Flex.Item>
    </Flex>
  </Box>
);
